module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Направить")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    attrs: {
      "label": "Описание уведомления",
      "rules": [function (v) { return !!v || 'введите краткое описание'; }],
      "rows": "3",
      "hint": "",
      "clearable": ""
    },
    model: {
      value: (_vm.contentText),
      callback: function($$v) {
        _vm.contentText = $$v
      },
      expression: "contentText"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "prepend-icon": "attach_file",
      "label": "Ссылка на документ",
      "rules": [function (v) { return !!v || 'cсылка должна быть указана'; }],
      "hint": "",
      "clearable": ""
    },
    on: {
      "click:prepend": _vm.dialogOpen
    },
    model: {
      value: (_vm.item.link),
      callback: function($$v) {
        _vm.$set(_vm.item, "link", $$v)
      },
      expression: "item.link"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-date-field', {
    attrs: {
      "label": "Ознакомиться до",
      "rules": [],
      "hint": ""
    },
    model: {
      value: (_vm.item.expiryTime),
      callback: function($$v) {
        _vm.$set(_vm.item, "expiryTime", $$v)
      },
      expression: "item.expiryTime"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51f57f5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/PostNotifyForm.vue
// module id = 1205
// module chunks = 1